import { render, staticRenderFns } from "./IssuesListCollection.vue?vue&type=template&id=2cbea63e&scoped=true&"
import script from "./IssuesListCollection.vue?vue&type=script&lang=js&"
export * from "./IssuesListCollection.vue?vue&type=script&lang=js&"
import style0 from "./IssuesListCollection.vue?vue&type=style&index=0&id=2cbea63e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbea63e",
  null
  
)

export default component.exports